import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import {
  faAbacus,
  faIndustryAlt,
  faDiceD20,
} from '@fortawesome/pro-light-svg-icons'

const getAvatar = function(label) {
  switch (label) {
    case 'Firma':
      return {
        icon: faIndustryAlt,
        iconColorClass: 'avatarColorFirma',
      }
    case 'Biuro rachunkowe':
      return {
        icon: faAbacus,
        iconColorClass: 'avatarColorBiuro',
      }
    default:
      return {
        icon: faDiceD20,
        iconColorClass: 'avatarColorPremium',
      }
  }
}

export default function WariantLicencjiAwatar({ wersja }) {
  return (
    <span className="fa-layers avatarContainer">
      <FontAwesomeIcon
        icon={faCircle}
        className={'avatarBackground ' + getAvatar(wersja).iconColorClass}
      />
      <FontAwesomeIcon
        icon={getAvatar(wersja).icon}
        className={'avatarIcon ' + getAvatar(wersja).iconColorClass}
      />
    </span>
  )
}
